// extracted by mini-css-extract-plugin
export default {"root":"CustomMultiSelect_root__NMojo","select":"CustomMultiSelect_select__TycFw"};